export const translations = {
  fr: {
    header: {
      home: "Accueil",
      concept: "Concept",
      services: "Services",
      contact: "Contact",
    },
    hero: {
      titleLine1: "Transformez chaque billet en une",
      titleLine2: "expérience.",
      subtitle:
        "one ticket est une API qui se connecte a votre billetteire existante vous permettant de programmer des d'experiences clients directement dans le billet de vos spectateurs.",
      ctaPrimary: "Demander un devis",
      ctaSecondary: "Nos Services",
    },
    integrations: {
      title: "ILS NOUS FONT CONFIANCE",
    },
    concept: {
      title: "NOTRE",
      titleSpan: "CONCEPT",
      subtitle: "Une solution 360° pour les organisateurs exigeants.",
      pillars: [
        {
          title: "Anti-fraude",
          subtitle: "Éliminez les faux billets.",
          desc: "Chaque billet devient unique, traçable et infalsifiable. Fini les PDF copiés, les captures d’écran ou les reventes frauduleuses.",
        },
        {
          title: "Revente contrôlée",
          subtitle: "Reprenez le contrôle du marché secondaire.",
          desc: "Autorisez la revente dans un cadre que vous définissez. Fixez les règles, gardez les commissions, supprimez les plateformes externes.",
        },
        {
          title: "Fan Engagement",
          subtitle: "Transformez votre billet en expérience.",
          desc: "Votre billet devient programmable. Vous pouvez y intégrer des récompenses, des jeux, des offres ou des expériences personnalisées.",
        },
      ],
      // SÉQUENCE 1 : FAN ENGAGEMENT
      tickets: [
        {
          title: "Le Ticket Légende",
          features: [
            {
              label: "Badge collector",
              text: "\"J'y étais...\" - Un souvenir numérique impérissable de l'événement.",
            },
            {
              label: "Contenu exclusif",
              text: "Accès à des vidéos des coulisses, interviews ou discours du capitaine.",
            },
            {
              label: "Privilèges",
              text: "Accès automatique à des concours, tirages au sort exclusifs et avantages VIP.",
            },
          ],
        },
        {
          title: "Le Billet Partenaire",
          features: [
            {
              label: "Co-branding",
              text: 'Exemple : Billet "Redbull Experience", entièrement personnalisé aux couleurs du partenaire officiel.',
            },
            {
              label: "Gamification",
              text: "Des offres commerciales conditionnées aux performances sportives (Ex: -20% boutique si victoire avec plus de 2 buts).",
            },
            {
              label: "ROI Sponsor",
              text: "Un nouveau canal d'activation direct pour vos sponsors, mesurable et engageant.",
            },
          ],
        },
        {
          title: "Le Billet Digital (Fan à distance)",
          features: [
            {
              label: "Activation globale",
              text: "Monétisez toute votre base de fans sur les réseaux sociaux.",
            },
            {
              label: "Espace Fan virtuel",
              text: "Un billet virtuel co-brandé donnant accès à un espace interactif exclusif.",
            },
            {
              label: "Live & Récompenses",
              text: "Vidéos exclusives, statistiques en live, quiz en direct et récompenses.",
            },
          ],
        },
      ],
      conclusionFan:
        "Vous imaginez l’activation. Nous l’intégrons dans le billet.",
      weather:
        "Nouveauté 2026 : Protection contre les intempéries. Notre partenaire est la seule solution qui rembourse vos spectateurs en cas de mauvaises conditions météorologiques.",
      // SÉQUENCE 2 : ANTI-FRAUDE
      antifraudFeatures: [
        {
          title: "Billet unique et sécurisé",
          text: "Notre technologie rend chaque billet cryptographiquement infalsifiable.",
        },
        {
          title: "Traçabilité complète",
          text: "Suivez le cycle de vie de chaque billet, de l'émission jusqu'au scan au portique.",
        },
        {
          title: "Identification des catégories et profils",
          text: "Sachez exactement qui est dans votre stade, pas seulement qui a acheté le billet.",
        },
        {
          title: "Protection des revenus",
          text: "Mettez fin à la fraude qui vous fait perdre des milliers d'euros à chaque événement.",
        },
        {
          title: "Réduction des litiges",
          text: "Fluidifiez l'accès aux portiques et soulagez vos équipes de sécurité.",
        },
      ],
      conclusionFraud:
        "Un billet ne peut plus être copié. Il peut seulement être validé.",

      // SÉQUENCE 3 : REVENTE
      resaleFeatures: [
        {
          title: "Plafond de prix configurable",
          text: "Empêchez la spéculation en fixant un prix maximum autorisé pour la revente.",
        },
        {
          title: "Commission 100% pour l’organisateur",
          text: "Récupérez la valeur générée sur le marché secondaire, au lieu de la laisser aux plateformes.",
        },
        {
          title: "Historique des transferts",
          text: "Conservez une trace immuable et transparente de chaque transfert de propriété.",
        },
        {
          title: "Fin du marché noir",
          text: "Court-circuitez techniquement les plateformes non officielles.",
        },
        {
          title: "Meilleure visibilité des flux",
          text: "Anticipez le remplissage réel de vos événements grâce aux données en temps réel.",
        },
      ],
      conclusionResale:
        "Vous décidez qui peut revendre, à quel prix, et dans quelles conditions.",
    },
    services: {
      title: "NOTRE",
      titleSpan: "VALEUR AJOUTÉE",
      subtitle:
        "Une couche de performance qui s'intègre à votre billetterie existante via API.",
      list: [
        {
          title: "INTELLIGENCE DATA",
          subtitle: "Exploitation de la donnée billetterie et comportementale",
          description:
            "Nous centralisons et nettoyons vos données pour une vision 360° de vos spectateurs. Segmentez vos publics (VIP, Familles, Nouveaux) et identifiez vos leviers de croissance.",
          points: [
            "Transparence",
            "Segmentation automatique",
            "Reporting temps réel",
            "Conformité RGPD totale",
          ],
        },
        {
          title: "EXPÉRIENCE & REVENUS",
          subtitle: "Augmentez le panier moyen sans effort",
          description:
            "Transformez chaque billet en opportunité. Proposez des services additionnels (Upsell), des recommandations ciblées et des expériences digitales avant, pendant et après l'événement.",
          points: [
            "Upsell contextuel",
            "Parcours marque blanche",
            "Activation CRM",
            "Engagement des fans",
          ],
        },
        {
          title: "SÉCURITÉ & TRANSPARENCE",
          subtitle: "Technologie Web3 invisible pour le fan",
          description:
            "Nous utilisons la blockchain pour rendre chaque billet unique et infalsifiable. Pour l'utilisateur ? C'est transparent. Pour vous ? C'est le contrôle total sur la revente et la fin de la fraude.",
          points: [
            "0 risque de fraude",
            "Traçabilité du marché secondaire",
            "Expérience utilisateur fluide",
            "Preuve de propriété",
          ],
        },
        {
          title: "ACTIVATIONS SPONSORS",
          subtitle: "Associez une marque à chaque expérience.",
          description:
            "Impliquez vos sponsors et disposez d'un canal direct pour fidéliser, surprendre, remercier — même après le match ou le concert.",
          points: [
            "Le Billet Red Bull = accès rapide + boisson offerte",
            "Nouvel espace de visibilité pour vos sponsors",
            "Technology Web3 invisible",
            "Objets digitaux commémoratifs",
          ],
        },
      ],
    },
    impact: {
      techTitle: "ZERO FRICTION,",
      techTitleSpan: "PLUG & PLAY",
      techDesc:
        "Pas besoin de changer votre billetterie actuelle. Une simple API à connecter pour ajouter une couche d'intelligence et de revenus à votre opérateur actuel.",
      stats: [
        {
          label: "Revenus Merchandising",
          desc: "L'upsell contextuel booste vos ventes après match.",
        },
        {
          label: "Billetterie Revendue",
          desc: "Encadrez le marché secondaire et récupérez des commissions.",
        },
        {
          label: "Base Fan Activable",
          desc: "Transformez des spectateurs anonymes en leads qualifiés.",
        },
      ],
      levers: [
        {
          title: "Monétisation Sponsors",
          desc: "Associez une marque à chaque billet (Ex: Billet Red Bull = Accès rapide). Créez de nouveaux inventaires digitaux vendables.",
        },
        {
          title: "Engagement Post-Event",
          desc: "Le billet ne meurt pas à la fin du match. Il devient un canal direct pour remercier, surprendre et fidéliser vos fans toute l'année.",
        },
      ],
    },
    faq: {
      title: "QUESTIONS",
      titleSpan: "FRÉQUENTES",
      groups: [
        {
          category: "Fonctionnement & Intégration",
          questions: [
            {
              q: "Est-ce que vous remplacez notre solution de billetterie ?",
              a: "Non, absolument pas. Nous venons en complément (couche additionnelle). Nous nous connectons via API à votre billetterie actuelle (Secutix, Weezevent, Vivenu, etc.) pour ajouter des fonctionnalités sans perturber vos opérations.",
            },
            {
              q: "Combien de temps prend la mise en place ?",
              a: "L'intégration est rapide : comptez environ 1 mois pour la connexion API, les tests et la mise en production. Vos équipes n'ont aucune migration complexe à gérer.",
            },
            {
              q: "Est-ce compatible avec les ventes physiques ?",
              a: "Oui, notre solution unifie les données issues des ventes en ligne et des ventes physiques (guichets), pour une vision complète de vos spectateurs.",
            },
          ],
        },
        {
          category: "Données & Sécurité",
          questions: [
            {
              q: "Qui est propriétaire des données collectées ?",
              a: "OneTicket est propriétaire de la structure, mais les données sont les vôtres. Elles sont anonymisées et exploitables uniquement dans le cadre de votre événement. Nous ne les revendons jamais.",
            },
            {
              q: "Comment garantissez-vous la conformité RGPD ?",
              a: "Notre solution est 'Privacy by Design'. Les spectateurs sont identifiés par un ID unique sécurisé. Aucune donnée personnelle sensible n'est stockée sans nécessité absolue et consentement.",
            },
            {
              q: "À quoi sert la blockchain dans votre solution ?",
              a: "Chaque billet est associé à un NFT invisible. Cela garantit une traçabilité totale, empêche la fraude (faux billets) et sécurise le marché secondaire (revente), le tout sans friction pour l'utilisateur.",
            },
          ],
        },
      ],
    },
    contact: {
      title: "NOUS",
      titleSpan: "CONTACTER",
      subtitle: "Prêt à booster votre billetterie ? Parlons-en.",
      form: {
        nom: "Nom",
        prenom: "Prénom",
        entreprise: "Entreprise",
        email: "Email Pro",
        message: "Message",
        placeholders: {
          nom: "Votre nom",
          prenom: "Votre prénom",
          entreprise: "Nom de votre société",
          email: "contact@entreprise.com",
          message: "Décrivez votre besoin...",
        },
        submit: "Envoyer",
        sending: "Envoi en cours...",
      },
      success: {
        title: "Message envoyé !",
        thankYou: "Merci",
        teamResponse: "notre équipe vous répondra sous 24h.",
        reset: "Envoyer un autre message",
      },
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    footer: {
      slogan: "All you need is One Ticket.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      btnContact: "Nous contacter",
      copyright: "Tous droits réservés.",
    },
    weather: {
      badge: "NOUVEAUTÉ 2026",
      title: "Protection contre les",
      titleHighlight: "Intempéries",
      subtitle:
        "Notre partenaire est la seule solution qui rembourse vos spectateurs en cas de mauvaises conditions météorologiques.",
      benefits: [
        {
          title: "Clients satisfaits, peu importe la météo",
          points: [
            "Remboursement de 50% du prix du billet, sans formalité.",
            "Vos clients n'ont pas besoin d'annuler.",
            "Remboursement par courriel sous 48 heures.",
          ],
        },
        {
          title: "Augmentez vos ventes sans effort",
          points: [
            "Jusqu'à 18% de réservations supplémentaires.",
            "Revenus annexes sans frais d'installation.",
            "Les remboursements augmentent les dépenses sur place.",
          ],
        },
      ],
      journeyTitle: "Le parcours spectateur",
      steps: [
        { title: "Réservation", desc: "Réservation à l'avance, sans crainte." },
        { title: "Prévisions", desc: "Annonce de pluie le jour J." },
        { title: "Notification", desc: "SMS automatique de remboursement." },
        { title: "Sur place", desc: "Dépenses réinjectées sur l'événement." },
      ],
    },
  },
  en: {
    header: {
      home: "Home",
      concept: "Concept",
      services: "Services",
      contact: "Contact",
    },
    hero: {
      titleLine1: "THE EXCELLENCE OF",
      titleLine2: "EVENT MANAGEMENT",
      subtitle:
        "One Ticket is an API that connects to your existing ticketing system, allowing you to program customer experiences directly into your spectators' tickets.",
      ctaPrimary: "Request a Quote",
      ctaSecondary: "Our Services",
    },
    integrations: {
      title: "THEY ALREADY TRUST US",
    },
    concept: {
      title: "OUR",
      titleSpan: "CONCEPT",
      subtitle: "A 360° solution for demanding organizers.",
      weather:
        "NEW IN 2026: Bad Weather Protection. Our partner is the only solution that refunds your attendees in case of poor weather conditions.",
      pillars: [
        {
          title: "Anti-fraud",
          subtitle: "Eliminate fake tickets.",
          desc: "Each ticket becomes unique, traceable, and unforgeable. No more copied PDFs, screenshots, or fraudulent resales.",
        },
        {
          title: "Controlled Resale",
          subtitle: "Regain control of the secondary market.",
          desc: "Allow resale within a framework you define. Set the rules, keep the commissions, eliminate external platforms.",
        },
        {
          title: "Fan Engagement",
          subtitle: "Turn your ticket into an experience.",
          desc: "Your ticket becomes programmable. You can integrate rewards, games, offers, or personalized experiences.",
        },
      ],
      // SÉQUENCE 1 : FAN ENGAGEMENT
      tickets: [
        {
          title: "The Legend Ticket",
          features: [
            {
              label: "Collector's badge",
              text: '"I was there..." - An everlasting digital souvenir of the event.',
            },
            {
              label: "Exclusive content",
              text: "Access to behind-the-scenes videos, interviews, or captain's speeches.",
            },
            {
              label: "Privileges",
              text: "Automatic access to contests, exclusive draws, and VIP perks.",
            },
          ],
        },
        {
          title: "The Partner Ticket",
          features: [
            {
              label: "Co-branding",
              text: 'Example: "Redbull Experience" ticket, fully customized with official partner colors.',
            },
            {
              label: "Gamification",
              text: "Commercial offers conditional on sports performance (e.g., 20% off shop if win by 2+ goals).",
            },
            {
              label: "Sponsor ROI",
              text: "A new direct activation channel for your sponsors, measurable and engaging.",
            },
          ],
        },
        {
          title: "The Digital Ticket (Remote Fan)",
          features: [
            {
              label: "Global activation",
              text: "Monetize your entire fan base on social media.",
            },
            {
              label: "Virtual Fan Space",
              text: "A co-branded virtual ticket granting access to an exclusive interactive space.",
            },
            {
              label: "Live & Rewards",
              text: "Exclusive videos, live stats, live quizzes, and rewards.",
            },
          ],
        },
      ],
      conclusionFan:
        "You imagine the activation. We integrate it into the ticket.",

      // SÉQUENCE 2 : ANTI-FRAUDE
      antifraudFeatures: [
        {
          title: "Unique and secure ticket",
          text: "Our technology makes each ticket cryptographically unforgeable.",
        },
        {
          title: "Complete traceability",
          text: "Track the lifecycle of each ticket, from issuance to the turnstile scan.",
        },
        {
          title: "Category and profile identification",
          text: "Know exactly who is in your stadium, not just who bought the ticket.",
        },
        {
          title: "Revenue protection",
          text: "Stop the fraud that causes you to lose thousands of euros at every event.",
        },
        {
          title: "Reduced disputes",
          text: "Streamline access at the turnstiles and relieve your security teams.",
        },
      ],
      conclusionFraud:
        "A ticket can no longer be copied. It can only be validated.",

      // SÉQUENCE 3 : REVENTE
      resaleFeatures: [
        {
          title: "Configurable price cap",
          text: "Prevent speculation by setting a maximum authorized resale price.",
        },
        {
          title: "100% organizer commission",
          text: "Recover the value generated on the secondary market, instead of leaving it to platforms.",
        },
        {
          title: "Transfer history",
          text: "Keep an immutable and transparent record of every ownership transfer.",
        },
        {
          title: "End of the black market",
          text: "Technically bypass unofficial platforms.",
        },
        {
          title: "Better flow visibility",
          text: "Anticipate the actual attendance of your events with real-time data.",
        },
      ],
      conclusionResale:
        "You decide who can resell, at what price, and under what conditions.",
    },
    services: {
      title: "OUR",
      titleSpan: "ADDED VALUE",
      subtitle:
        "A performance layer that integrates with your existing ticketing via API.",
      list: [
        {
          title: "DATA INTELLIGENCE",
          subtitle: "Exploitation of ticketing and behavioral data",
          description:
            "We centralize and clean your data for a 360° view of your attendees. Segment your audiences (VIP, Families, Newcomers) and identify your growth levers.",
          points: [
            "Transparency",
            "Automated segmentation",
            "Real-time reporting",
            "Full GDPR compliance",
          ],
        },
        {
          title: "EXPERIENCE & REVENUE",
          subtitle: "Increase average basket size effortlessly",
          description:
            "Transform every ticket into an opportunity. Offer additional services (Upsell), targeted recommendations, and digital experiences before, during, and after the event.",
          points: [
            "Contextual Upsell",
            "White-label journey",
            "CRM Activation",
            "Fan Engagement",
          ],
        },
        {
          title: "SECURITY & TRANSPARENCY",
          subtitle: "Web3 technology invisible to the fan",
          description:
            "We use blockchain to make every ticket unique and tamper-proof. For the user? It's transparent. For you? It's total control over resale and the end of fraud.",
          points: [
            "0 fraud risk",
            "Secondary market traceability",
            "Seamless user experience",
            "Proof of ownership",
          ],
        },
        {
          title: "SPONSOR ACTIVATIONS",
          subtitle: "Associate a brand with every experience.",
          description:
            "Involve your sponsors and have a direct channel to retain, surprise, thank — even after the match or concert.",
          points: [
            "The Red Bull Ticket = fast track + free drink",
            "New visibility space for your sponsors",
            "Invisible Web3 Technology",
            "Commemorative digital objects",
          ],
        },
      ],
    },
    impact: {
      techTitle: "ZERO FRICTION,",
      techTitleSpan: "PLUG & PLAY",
      techDesc:
        "No need to change your current ticketing system. A simple API to connect to add a layer of intelligence and revenue to your current operator.",
      stats: [
        {
          label: "Merchandising Revenue",
          desc: "Contextual upsell boosts your post-match sales.",
        },
        {
          label: "Resold Ticketing",
          desc: "Control the secondary market and earn commissions.",
        },
        {
          label: "Activable Fan Base",
          desc: "Transform anonymous spectators into qualified leads.",
        },
      ],
      levers: [
        {
          title: "Sponsor Monetization",
          desc: "Associate a brand with every ticket (Ex: Red Bull Ticket = Fast Track). Create new sellable digital inventories.",
        },
        {
          title: "Post-Event Engagement",
          desc: "The ticket doesn't die at the end of the match. It becomes a direct channel to thank, surprise, and retain your fans all year round.",
        },
      ],
    },
    faq: {
      title: "FREQUENTLY ASKED",
      titleSpan: "QUESTIONS",
      groups: [
        {
          category: "Operation & Integration",
          questions: [
            {
              q: "Do you replace our ticketing solution?",
              a: "No, absolutely not. We come as an addition (layer). We connect via API to your current ticketing system (Secutix, Weezevent, Vivenu, etc.) to add features without disrupting your operations.",
            },
            {
              q: "How long does setup take?",
              a: "Integration is fast: allow about 1 month for API connection, testing, and go-live. Your teams don't have to handle complex migrations.",
            },
            {
              q: "Is it compatible with physical sales?",
              a: "Yes, our solution unifies data from online sales and physical sales (box office), for a complete view of your spectators.",
            },
          ],
        },
        {
          category: "Data & Security",
          questions: [
            {
              q: "Who owns the collected data?",
              a: "OneTicket owns the structure, but the data is yours. It is anonymized and usable only within the context of your event. We never resell it.",
            },
            {
              q: "How do you guarantee GDPR compliance?",
              a: "Our solution is 'Privacy by Design'. Spectators are identified by a secure unique ID. No sensitive personal data is stored without absolute necessity and consent.",
            },
            {
              q: "What is blockchain used for in your solution?",
              a: "Every ticket is associated with an invisible NFT. This guarantees total traceability, prevents fraud (fake tickets), and secures the secondary market (resale), all without friction for the user.",
            },
          ],
        },
      ],
    },
    contact: {
      title: "CONTACT",
      titleSpan: "US",
      subtitle: "Ready to boost your ticketing? Let's talk.",
      form: {
        nom: "Last Name",
        prenom: "First Name",
        entreprise: "Company",
        email: "Business Email",
        message: "Message",
        placeholders: {
          nom: "Your last name",
          prenom: "Your first name",
          entreprise: "Company name",
          email: "contact@company.com",
          message: "Describe your needs...",
        },
        submit: "Send",
        sending: "Sending...",
      },
      success: {
        title: "Message sent!",
        thankYou: "Thank you",
        teamResponse: "our team will answer you within 24h.",
        reset: "Send another message",
      },
      error: "An error occurred. Please try again.",
    },
    footer: {
      slogan: "All you need is One Ticket.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      btnContact: "Contact us",
      copyright: "All rights reserved.",
    },
    weather: {
      badge: "NEW IN 2026",
      title: "Bad Weather",
      titleHighlight: "Protection",
      subtitle:
        "Our partner is the only solution that refunds your attendees in case of poor weather conditions.",
      benefits: [
        {
          title: "Happy customers, whatever the weather",
          points: [
            "50% ticket price refund, no questions asked.",
            "Your customers don't need to cancel.",
            "Refund via email within 48 hours.",
          ],
        },
        {
          title: "Increase your sales effortlessly",
          points: [
            "Up to 18% more advance bookings.",
            "Additional revenue with no setup fees.",
            "Refunds increase on-site spending.",
          ],
        },
      ],
      journeyTitle: "The Attendee Journey",
      steps: [
        { title: "Booking", desc: "Worry-free advance booking." },
        { title: "Forecast", desc: "Rain forecast on event day." },
        { title: "Notification", desc: "Automated SMS with refund details." },
        { title: "On-site", desc: "Money reinvested at the event." },
      ],
    },
  },
};
